/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: ANil
 */

/******** Reducers ********/

const initialState = {
  logo: '/assets/img/logo.png',
  url: '/assets/img/logo.png',
  portal_title: '',
  company_name: '',
  support_email: '',
  support_phone: '',
  address: null,
  isTenant: false,
  subdomain: '',
  loaded: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_WEB_DETAILS':
    case 'Logo': {
      const data = action.data || {};
      const logoUrl =
        data.logo || data.logo_url || data.fileUrl || data.url || state.logo;
      return {
        ...state,
        ...data,
        logo: logoUrl,
        url: logoUrl,
        loaded: true,
      };
    }

    default:
      return state;
  }
}

  